import type { FunctionComponent } from "react";

import type { TabContent } from "./tab-content";

export type TabsCmp<P> = FunctionComponent<P> & {
  Content: typeof TabContent;
};

export const tabsVariants = ["line", "contained"] as const;

export type TabsVariant = (typeof tabsVariants)[number];

export const createTabChangeDetailEvent = (value: string) =>
  new CustomEvent<TabChangeDetail>("tabChangeDetail", { detail: { value } });

export type TabChangeDetail = { value: string };
